import { useNavigate, useSearchParams } from "react-router";
import TagForm from "../components/Settings/Tags/TagForm";
import { TagKind } from "../api/tagApi";

const KINDS: TagKind[] = ["role", "skill"];

const NewTag = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const raw = searchParams.get("kind");
  const kind: TagKind = KINDS.includes(raw as TagKind)
    ? (raw as TagKind)
    : "role";

  return (
    <TagForm
      kind={kind}
      onSaved={() => navigate(`/settings/tags?kind=${kind}`)}
    />
  );
};

export default NewTag;
